import i18next from 'i18next'

i18next.addResources('es', 'profile', {
  family: 'Mi entorno',
  be: 'Mi forma de ser',
  event: 'Mis acontecimientos',
  finance: 'Mis finanzas'
})
